import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface IMessageProps {
  isBold?: boolean
  children: ReactNode
}

export const Message = (props: IMessageProps) => {
  const className = classnames({
    'ly-leave__msg': !props.isBold,
    'ly-leave__msg--b': props.isBold,
  })

  return <p className={className}>{props.children}</p>
}
